class CartItem extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ['remove']
  }

  constructor() {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
  }

  setupListeners() {
    super.setupListeners()

    this.removeLineItem = this.removeLineItem.bind(this)
    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.debouncedOnQuantityChange = window.BAO.Utils.debounce(event => {
      this.onQuantityChange(event)
    }, 500)

    if (this.els?.remove.exists) {
      this.listeners.add(this.els.remove.element, 'click', this.removeLineItem)
    }

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    )
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  async removeLineItem(e) {
    e.preventDefault()

    this.loading = true

    const state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
    })

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  async onQuantityChange(e) {

    this.loading = true

    const state = await window.BAO.Cart.updateQuantity(
      this.dataset.key,
      e.detail.value,
      { sections: this.mappedSections },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)

  }

  /*
  async onQuantityChange(e) {

    this.loading = true

    if (this.canUpdate(e.detail.value)) {

      await this.updateBundleItemQuantities(e.detail.value)

      const state = await window.BAO.Cart.updateQuantity(
        this.dataset.key,
        e.detail.value,
        { sections: this.mappedSections },
      )

      this.loading = false

      if ('sections' in state) this.renderSections(state.sections)

    } else {
      e.target.value = e.detail.oldValue
    }

    this.loading = false

  }

  canUpdate(quantity) {
    const bundleStopSellingAtPropertyKey = window.theme.strings?.lineItemProperties?.bundles?.propertyKeys?.bundleStopSellingAt
    const lineItem = this.lineItems.find(lineItem => lineItem.key === this.dataset.key)
    const stopSellingAt = lineItem.properties[bundleStopSellingAtPropertyKey]
    if (!lineItem || !bundleStopSellingAtPropertyKey || !stopSellingAt) return true
    return (parseInt(quantity, 10) <= parseInt(stopSellingAt, 10))
  }

  async updateBundleItemQuantities(quantity) {

    const bundleParentPropertyKey = window.theme.strings?.lineItemProperties?.bundles?.propertyKeys?.bundleParent
    const bundleItemPropertyKey = window.theme.strings?.lineItemProperties?.bundles?.propertyKeys?.bundleItem
    const bundleIdentifierPropertyKey = window.theme.strings?.lineItemProperties?.bundles?.propertyKeys?.bundleIdentifier
    const bundleItemQuantityPropertyKey = window.theme.strings?.lineItemProperties?.bundles?.propertyKeys?.bundleItemQuantity

    if (!this.lineItems || !bundleParentPropertyKey || !bundleItemPropertyKey || !bundleIdentifierPropertyKey || !bundleItemQuantityPropertyKey) return

    const bundleParent = this.lineItems.find(lineItem => (lineItem.key === this.dataset.key && (bundleParentPropertyKey in lineItem.properties)))
    if (!bundleParent) return

    const bundleIdentifier = bundleParent?.properties[bundleIdentifierPropertyKey]
    const bundleItems = this.lineItems.filter(lineItem => (bundleItemPropertyKey in lineItem.properties) && lineItem?.properties[bundleIdentifierPropertyKey] === bundleIdentifier)

    if (!bundleItems.length) return

    const itemsToUpdate = bundleItems.map(bundleItem => {
      const itemQuantity = bundleItem.properties[bundleItemQuantityPropertyKey] || bundleItem.quantity
      return {
        id: bundleItem.id.toString(),
        quantity: (parseInt(itemQuantity, 10) * quantity).toString(),
        properties: bundleItem.properties,
      }
    })

    const keysToRemove = bundleItems.map(bundleItem => bundleItem.key)

    await window.BAO.Cart.removeItems(keysToRemove, { sections: [] })
    await window.BAO.Cart.addItem(itemsToUpdate, { sections: [] })

    return

  }
  */

  get mappedSections() {
    return this.sections.map(s => s.section)
  }

  get loading() {
    return this._loading
  }

  set loading(val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  get pushCart() {
    return this.closest('push-cart')
  }

  get inPushCart() {
    return this.pushCart != null
  }

  get cart() {
    return this.closest('cart-items')
  }

  get onCartPage() {
    return this.cart != null
  }

  get lineItemsEl() {
    return document.querySelector('[data-section-id="push-cart-data"]')
  }

  get lineItems() {
    return this.lineItemsEl ? JSON.parse(this.lineItemsEl.textContent) : null
  }
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', CartItem)
}
